module.exports = {
	displayVoting: true,
	proxyImages: true,
};
